export { Input, type InputProps } from './styled/input'
